import FirebaseHandler from "./index";
import { httpsCallable } from "firebase/functions";
export var createSubscription = function createSubscription(data) {
    var subscribe = httpsCallable(FirebaseHandler.functions, "createSubscription");
    return subscribe(data);
};
